export default __webpack_public_path__ + "static/anhaegnger-82b0f440611b5f529e88b8c8ca9f46c3.jpg";